<template lang="pug">
ods-module.loyalty-programs-detail(v-if="getProgramState")
  h1.loyalty-programs-detail__title {{ this.$t('loyalty.Bankstatement') }}
  div.loyalty-programs-detail__divisor-title
  div.loyalty-programs-detail__flex-row
    div.loyalty-programs-detail__flex-33-percent-column
      h2.loyalty-programs-detail__subtitle {{ this.$t('loyalty.mailstatement') }}
      span {{ data.indenvex }}
    div.loyalty-programs-detail__flex-33-percent-column
      h2.loyalty-programs-detail__subtitle {{ this.$t('loyalty.nextreleasedate') }}
      span {{ data.fechpenv | formatDateLocale }}
    div.loyalty-programs-detail__flex-33-percent-column
      h2.loyalty-programs-detail__subtitle {{ this.$t('loyalty.maximumpoints') }}
      span {{ this.changeNumbers(this.getLang, data.numtopto) }}
  h1.loyalty-programs-detail__title {{ this.$t('loyalty.points') }}
  div.loyalty-programs-detail__divisor-title
  div.loyalty-programs-detail__flex-row
    div.loyalty-programs-detail__flex-33-percent-column
      h2.loyalty-programs-detail__subtitle {{ this.$t('loyalty.expirationcriteria') }}
      span {{ this.cambiarCriterio(data.xcritcad).toUpperCase() }}
    div.loyalty-programs-detail__flex-33-percent-column
      h2.loyalty-programs-detail__subtitle {{ this.$t('loyalty.periodValidity') }}
      span {{ data.pervigen }}
    div.loyalty-programs-detail__flex-33-percent-column
      h2.loyalty-programs-detail__subtitle {{ this.$t('loyalty.periodicity') }}
      span {{ data.perrevpt }}
ods-module.loyalty-programs-detail(v-else v-loading="true" loading-spinner="spinner")
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    data: {
      type: Object
    }
  },
  name: 'OperativosTable',
  data: () => {
    return {
      maximumPoints: 0
    }
  },
  computed: {
    ...mapGetters({
      getProgramState: 'getProgramState',
      getLang: 'getLang'
    })
  },
  methods: {
    changeNumbers (data, number) {
      const newNumber = new Intl.NumberFormat(data).format(number)
      return newNumber
    },
    actualizarCampo (data) {
      if (data === 0) {
        return this.$t('loyalty.no')
      }
      if (data === 1) {
        return this.$t('loyalty.yes')
      }
    },
    cambiarCriterio (data) {
      if (data === 0) {
        return this.$t('loyalty.noExpirationDate')
      }
      if (data === 1) {
        return this.$t('loyalty.directedOlder')
      }
      if (data === 2) {
        return this.$t('loyalty.directedNewest')
      }
      if (data === 3) {
        return this.$t('loyalty.customerCategory')
      }
    }
  },
  watch: {
    getLang (data, oldData) {
      if (data === 'es') {
        this.changeNumbers('es-ES')
      }
      if (data === 'en') {
        this.changeNumbers('en-EN')
      }
      if (data === 'es-co') {
        this.changeNumbers('es-CO')
      }
    }
  }
}
</script>
<style lang="scss">
.loyalty-programs-detail{
  padding: rem(24) rem(32);
  &__flex-row{
   display: flex;
   flex-direction: row;
   flex-wrap: wrap;
   margin-top: rem(16);
   margin-bottom: rem(15);
  }

  &__flex-33-percent-column{
    width: 33.33%;
    margin-bottom: rem(15);
  }

  &__divisor{
   border: 1px solid #F0F0F0;
   margin: rem(32) 0 rem(32) 0;
  }

  &__divisor-title{
   border: 1px solid #F0F0F0;
   margin: rem(8) 0 rem(24) 0;
  }

  &__title{
    font-size: rem(16);
    line-height: rem(24);
    margin-bottom: rem(16);
    display: flex;
    align-items: center;
    font-weight: 500;
  }

  &__subtitle{
    font-size: rem(12);
    line-height: rem(24);
    margin-bottom: rem(8);
    text-transform: uppercase;
    color: #6E767D;
    font-weight: 400;
  }
}
</style>
